import React from "react";
import Modal from "react-bootstrap/Modal";
import CashPassbookViewer from "./CashPassbookViewer";

const CashPassbookEntriesModal = ({
  show,
  storeId,
  passbookId,
  handleClose
}) => {
  const hasSelection = Boolean(storeId && passbookId);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      fullscreen
      scrollable
      aria-labelledby="cash-passbook-entries-title"
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="cash-passbook-entries-title"
          style={{ fontSize: "18px", fontWeight: 600 }}
        >
          <i className="fa fa-book me-2" aria-hidden="true" />
          Passbook Transactions
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          background: "#f5f7fb",
          padding: "16px"
        }}
      >
        {show && hasSelection ? (
          <CashPassbookViewer
            key={`${storeId}-${passbookId}`}
            embedded
            initialStoreId={String(storeId)}
            initialPassbookId={String(passbookId)}
          />
        ) : (
          <div className="alert alert-warning">
            Please select a valid store and passbook.
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CashPassbookEntriesModal;